import React from 'react';
import './Header.css';

const Header = ({ onReset }) => {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="app-title">Solutioning Agent</h1>
        <p className="app-subtitle">consumr.ai</p>
      </div>
      <button className="reset-button" onClick={onReset}>
        + New Conversation
      </button>
    </header>
  );
};

export default Header;
